import {useEffect, useRef, useState} from 'react';

const PLACEHOLDER_INTERVAL_MS = 2000;

export const useSearchInputPlaceholder = (defaultPlaceholder?: string, placeholderArr?: string[]) => {
    const idxRef = useRef<number>(0);
    const [, forceUpdate] = useState(0);
    const arrayLength = placeholderArr?.length ?? 0;

    useEffect(() => {
        if (1 >= arrayLength) {
            return;
        }

        const intervalId = setInterval(() => {
            idxRef.current = (idxRef.current + 1) % arrayLength;
            forceUpdate((prev) => prev + 1);
        }, PLACEHOLDER_INTERVAL_MS);

        // eslint-disable-next-line consistent-return
        return () => clearInterval(intervalId);
    }, [arrayLength]);

    if (0 === arrayLength) {
        return defaultPlaceholder;
    }

    if (1 === arrayLength) {
        return placeholderArr?.[0];
    }

    return placeholderArr?.[idxRef.current];
};
